import {Modal} from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import React, {useEffect, useState} from 'react';
import {LOCAL_STORAGE_USER_LOGIN_INFO, SHOW_CANDIDATE_MODE} from "@app/constants/Common";
import Select from "react-select";
import {requestGetUserList} from "@app/services/UserService";
import {saveShowHideCandidates} from "@app/services/CandidateService";
import {arrayToString, stringToArray} from "@app/utils/CommonUtils";
import {toast} from "react-toastify";
import {Messages} from "@app/constants/Messages";
import {Link} from "react-router-dom";

const ShowHideCandidatesModal = (props) => {
    const [selectUsers, setSelectUsers] = useState([]);
    const [isSelectAllUsers, setIsSelectAllUsers] = useState(true);
    const [showProcessResult, setShowProcessResult] = useState(false);
    const [showMode, setShowMode] = useState(SHOW_CANDIDATE_MODE[0].value);
    const [userOptions, setUserOptions] = useState([]);
    const [successShowItems, setSuccessShowItems] = useState({});
    const [failedHideItems, setFailedHideItems] = useState({});
    const [userLoginInfo, setUserLoginInfo] = useState({});

    const [isLoading, setIsLoading] = useState(false)
    const {isShow} = props
    const {candidateIds} = props
    const {onClose} = props

    useEffect(() => {
        if (!userLoginInfo.id && localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)) {
            setUserLoginInfo(JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)))
        }
    },[]);

    const fetchUsers = async () => {
        const res = await requestGetUserList({});
        const userList = res.content.users
        const userOptionList = []
        userList.forEach(user => {
            if (!user.is_superuser) {
                userOptionList.push({value: user.id, label: user.email})
            }
        })
        setUserOptions(userOptionList);
    };

    useEffect(() => {
        if (isShow && userLoginInfo.is_superuser) {
            fetchUsers()
        }
    },[isShow]);

    const closeModal = (success) => {
        setSelectUsers([])
        setIsSelectAllUsers(true)
        setShowProcessResult(false)
        onClose(success)
    }

    const onSaveShowHideCandidates = () => {
        setIsLoading(true)
        let requestBody = {
            is_all_users: isSelectAllUsers,
            candidate_ids: candidateIds,
            show_mode: showMode,
            user_ids: [],
        }
        requestBody.user_ids = selectUsers.map(item => {
            return item.value
        })

        saveShowHideCandidates(requestBody).then((res) => {
            console.log(`Response-saveShowHideCandidatese:${JSON.stringify(res)}`);
            const successObjectItems = {}
            res.content.success_show_items.forEach(item => {
                const arrCanIds = stringToArray(item.candidate_ids)
                arrCanIds.forEach(id => {
                    if (!successObjectItems[id]) {
                        successObjectItems[id] = {users: []}
                    }
                    successObjectItems[id].users.push(item.user_email)
                })
            })
            setSuccessShowItems(successObjectItems)

            const failedObjectItems = {}
            res.content.failed_hide_items.forEach(item => {
                const arrCanIds = stringToArray(item.candidate_ids)
                arrCanIds.forEach(id => {
                    if (!failedObjectItems[id]) {
                        failedObjectItems[id] = {users: []}
                    }
                    failedObjectItems[id].users.push(item.user_email)
                })
            })
            setFailedHideItems(failedObjectItems)
            setShowProcessResult(true)
            toast.success(Messages.processSuccess)
        }).catch((error) => {
            console.log(`Error:${JSON.stringify(error)}`);
        }).finally(() => {
            setIsLoading(false);
        });
    }

    const onSelectMultiUsers = (values) => {
        setSelectUsers([...values]);
    };

    return (
        <>
            <Modal show={isShow}
                   size={'lg'}
                   onHide={() => closeModal()}
                   animation={false}>
                <Modal.Header>
                    <Modal.Title>Show/hide ứng viên</Modal.Title>
                    <Button variant='secondary' onClick={() => closeModal()}>
                        Close
                    </Button>
                </Modal.Header>
                <Modal.Body>
                    <div className='row'>
                        <div className='col-sm-12'>
                            <div className='input-group'>
                                <div className='input-group'>
                                    <label>Tất cả users</label>
                                    <input type="checkbox"
                                           className="ml-3" name={'only_user_input'}
                                           style={{width: 20, height: 20}}
                                           value={isSelectAllUsers}
                                           checked={isSelectAllUsers}
                                           onChange={() => {
                                               setSelectUsers([])
                                               setIsSelectAllUsers(!isSelectAllUsers)
                                           }}/>
                                </div>
                                <div style={{width: '100%'}}>
                                    <Select options={userOptions}
                                            isMulti
                                            placeholder={"Chọn users"}
                                            isDisabled={isSelectAllUsers}
                                            value={selectUsers}
                                            onChange={values => {
                                                onSelectMultiUsers(values);
                                            }}
                                    />
                                </div>
                            </div>
                            <div className='input-group mt-3'>
                                <label className={'w-100'}><b>Hide/Show</b></label>
                                <select className='form-control'
                                        name={'show_hide_state'}
                                        value={showMode}
                                        onChange={event => setShowMode(event.target.value)}>
                                    {SHOW_CANDIDATE_MODE.map(item => {
                                        return <option value={item.value} key={`show_hide_state_item_option_${item.value}`}>{item.label}</option>
                                    })}
                                </select>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button type='button'
                            className='btn btn-primary'
                            isLoading={isLoading}
                            disabled={
                                isLoading
                            }
                            onClick={() => {
                                onSaveShowHideCandidates()
                            }}
                            >
                        <i className='fas fa-save mr-2'/>
                        Save
                    </Button>
                </Modal.Footer>

                {showProcessResult && (Object.keys(failedHideItems).length > 0 || Object.keys(successShowItems).length > 0) &&
                <div className='card card-default m-3'>
                    <div className='card-header'>
                        {Object.keys(successShowItems).length > 0 &&
                        <h3 className='card-title text-bold'>UV chuyển từ Hide thành Show</h3>
                        }
                        {Object.keys(failedHideItems).length > 0 &&
                        <h3 className='card-title text-bold'>UV hide không thành công</h3>
                        }
                    </div>
                    <div className='card-body table-responsive p-0' >
                        <table
                            className='table table-hover table-bordered text-nowrap text-center'
                        >
                            <thead>
                            <tr>
                                <th>No.</th>
                                <th>UV ID</th>
                                <th>Users</th>
                            </tr>
                            </thead>
                            <tbody>
                            {Object.keys(failedHideItems).map((canId, index) => {
                                return <tr>
                                    <td>{index + 1}</td>
                                    <td>
                                        <Link to={`/candidate/detail/${canId}`} target="_blank"
                                              rel="noopener noreferrer">{canId}</Link>
                                    </td>
                                    <td>{arrayToString(failedHideItems[canId].users)}</td>
                                </tr>
                            })}
                            {Object.keys(successShowItems).map((canId, index) => (
                                <tr>
                                    <td>{index+1}</td>
                                    <td>
                                        <Link to={`/candidate/detail/${canId}`} target="_blank"
                                              rel="noopener noreferrer">{canId}</Link>
                                    </td>
                                    <td>{arrayToString(successShowItems[canId].users)}</td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    </div>
                </div>
                }
            </Modal>
        </>
    )
}

export default ShowHideCandidatesModal;
